import request from '@/plugin/axios'

export function queryShopHomeLink (pageable) {
  return request({
    url: '/api/admin/queryShopHomeLink',
    method: 'get',
    params: pageable
  })
}
export function addShopHomeLink (data) {
  return request({
    url: '/api/admin/addShopHomeLink',
    method: 'post',
    data: data
  })
}
export function updateShopHomeLink (data) {
  return request({
    url: '/api/admin/updateShopHomeLink',
    method: 'post',
    data: data
  })
}
export function deleteShopHomeLink (data) {
  return request({
    url: '/api/admin/deleteShopHomeLink',
    method: 'post',
    data: data
  })
}
